import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: "app-sync-success-dialog",
  templateUrl: "./sync-success-dialog.component.html",
  styleUrls: ["./sync-success-dialog.component.scss"],
  standalone: false,
})
export class SyncSuccessDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<SyncSuccessDialogComponent>,
    private router: Router,
  ) {}

  goToEmployees(): void {
    this.dialogRef.close();
    void this.router.navigate(["/employees"]);
  }

  close(): void {
    this.dialogRef.close();
  }
}
